@if (configuration) {
    <section
        class="nw-spotlight-block__container"
        [class.nw-spotlight-block__container--right]="configuration.layout === 'right'"
    >
        <div class="nw-spotlight-block__container__cards">
            @for (card of configuration.cards; track $index) {
                <nw-content-card
                    [heading]="card.header"
                    [content]="card.content"
                    [icon]="card.icon"
                    [clickableurl]="card.url"
                />
            }
        </div>

        <div class="nw-spotlight-block__container__media">
            <img
                class="nw-spotlight-block__container__media__image"
                [ngSrc]="configuration.media.image.path"
                [alt]="configuration.media.image.alt || ''"
                fill
            />

            <div
                class="nw-spotlight-block__container__media__overlay"
                [class.nw-spotlight-block__container__media__overlay--black]="
                    configuration.media.headerColour === 'black'
                "
            >
                <h2 class="nw-spotlight-block__container__media__overlay__header">
                    {{ configuration.media.header }}
                </h2>

                @if (configuration.media.cta?.label) {
                    <a
                        [href]="configuration.media.cta?.path"
                        class="nw-button nw-button--primary nw-button--m nw-spotlight-block__container__media__overlay__cta"
                    >
                        <span
                            [innerHTML]="configuration.media.cta?.label | sanitizeHtml"
                        ></span>
                    </a>
                }
            </div>

            @if (configuration.media.name || configuration.media.title) {
                <div
                    class="nw-spotlight-block__container__media__attribution"
                    [class.nw-spotlight-block__container__media__attribution--black]="
                        configuration.media.nameColour === 'black'
                    "
                >
                    @if (configuration.media.name) {
                        <p>{{ configuration.media.name }}</p>
                    }
                    @if (configuration.media.title) {
                        <p>{{ configuration.media.title }}</p>
                    }
                </div>
            }
        </div>
    </section>
}
